module.exports = __webpack_public_path__ + "static/media/sura-vial.5025cb74.svg";